import { render, staticRenderFns } from "./ResendConfirmationEmail.vue?vue&type=template&id=03a90448&scoped=true&"
import script from "./ResendConfirmationEmail.vue?vue&type=script&lang=js&"
export * from "./ResendConfirmationEmail.vue?vue&type=script&lang=js&"
import style0 from "./ResendConfirmationEmail.vue?vue&type=style&index=0&id=03a90448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a90448",
  null
  
)

export default component.exports